// Phone layout for every wide table (user 2026-10-15): on a phone, a table wider than the screen is shown as
// stacked cards — one card per row, each cell as "column name: value" — so no page needs sideways scrolling.
// Tables that fit stay as they are; a table can opt out with class "no-stack". Labels come from the table header.
import { FC, useEffect } from 'react';
import { useIsPhone } from '../../hooks/useIsPhone';

const label = (table: HTMLTableElement) => {
  const head = table.tHead?.rows?.[table.tHead.rows.length - 1];
  if (!head) return;
  const names: string[] = [];
  for (const th of Array.from(head.cells)) { const n = (th.textContent || '').replace(/[↕↑↓]/g, '').trim(); for (let k = 0; k < (th.colSpan || 1); k++) names.push(n); }
  for (const body of Array.from(table.tBodies)) for (const tr of Array.from(body.rows)) {
    let i = 0;
    for (const td of Array.from(tr.cells)) { if (!td.hasAttribute('data-label')) td.setAttribute('data-label', td.colSpan > 2 ? '' : names[i] || ''); i += td.colSpan || 1; }
  }
};

const PhoneTables: FC = () => {
  const phone = useIsPhone();
  useEffect(() => {
    if (!phone) { document.querySelectorAll('table.ptable').forEach((t) => t.classList.remove('ptable')); return; }
    let timer: any = null;
    const scan = () => {
      for (const t of Array.from(document.querySelectorAll('table:not(.no-stack)')) as HTMLTableElement[]) {
        if (!t.classList.contains('ptable')) { if (t.offsetParent && t.scrollWidth > window.innerWidth + 8 && t.tHead) t.classList.add('ptable'); else continue; }
        label(t);
      }
    };
    scan();
    const mo = new MutationObserver(() => { clearTimeout(timer); timer = setTimeout(scan, 250); });
    mo.observe(document.body, { childList: true, subtree: true });
    return () => { mo.disconnect(); clearTimeout(timer); };
  }, [phone]);
  return null;
};
export default PhoneTables;
